export const creatorConstants = {
    COLLECT_CREATOR_DATA: 'COLLECT_CREATOR_DATA',
    INIT_COLLECT_CREATOR_DATA: 'INIT_COLLECT_CREATOR_DATA',
};
